"use strict";
/*
A Shared plain GQL as plain string
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.signS3UrlTypeDefsAsPlainStr = void 0;
exports.signS3UrlTypeDefsAsPlainStr = `
type Query {
  get_signed_url(key: String, expiresIn: Int): String
}
`;
//# sourceMappingURL=signS3UrlTypeDefs.js.map